import { Injectable } from "@angular/core";
import { IAccount, IEthnicGroup, IHealthcareservice } from "@comunicare/comunicare-interfaces";
import { Observable, of } from "rxjs";
import { ApiService } from "../shared/api/api.service";
import { BaseApiService } from "../shared/api/baseApi.service";

@Injectable({
  providedIn: "root",
})
export class UserApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "User", // Theme !
      ["account"], // Post route paths
      ["me"], // Get route paths
      [], // Put route paths
      [] // Delete route paths
    );
  }

  // The configurator has no user search, the server exposes no route for it.
  public search(_search: string): Observable<IAccount[]> {
    return of([]);
  }

  public me(): Observable<IAccount> {
    return this.api.get(this.readRoutes[0]) as Observable<IAccount>;
  }

  public updateAccount(_account: IAccount): Observable<Record<string, never>> {
    return of({});
  }

  public getMyService(): Observable<IHealthcareservice> {
    return of(null);
  }

  public getAllEthnicGroups(): Observable<IEthnicGroup[]> {
    return of([]);
  }
}
